import type { Product } from '@libs/common-types';
import { saleExpired } from '@libs/core';

export type PriceDisplay = {
    values: number[];
    variant: 'primary' | 'disabled';
};

export const getPriceDisplay = ({ price }: Pick<Product, 'price'>): PriceDisplay => {
    const salePrice = typeof price.sale === 'number' && !saleExpired(price.saleValidUntil) ? price.sale : null;

    return salePrice === null
        ? { values: [price.original], variant: 'primary' }
        : { values: [salePrice, price.original], variant: 'disabled' };
};
